import { Amplify } from "aws-amplify";

// Values are baked in at build time via Vite's `import.meta.env`. See
// `apps/admin/.env.example` for the full list. All variables must be prefixed
// `VITE_` to be exposed to the client bundle.
const env = import.meta.env;

export function configureAmplify() {
  const userPoolId = env.VITE_COGNITO_USER_POOL_ID;
  const userPoolClientId = env.VITE_COGNITO_USER_POOL_CLIENT_ID;

  if (!userPoolId || !userPoolClientId) {
    console.warn(
      "[amplify] Missing VITE_COGNITO_USER_POOL_ID / VITE_COGNITO_USER_POOL_CLIENT_ID — auth will not work."
    );
    return;
  }

  // Region is derived from userPoolId (e.g. "ca-central-1_3HEh3mjnF" → "ca-central-1").
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: { email: true }
      }
    }
  });
}

export const apiConfig = {
  baseUrl: env.VITE_API_BASE_URL ?? "",
  wsUrl: env.VITE_WS_URL ?? "",
  assetsBaseUrl: env.VITE_ASSETS_BASE_URL ?? ""
};
